import { gql } from '@apollo/client';

export const DELETE_TRUSTS_USER_MUTATION = gql`
  mutation DeleteTrustsUser($trustsUserDeleteDto: TrustsUserDeleteDto!) {
    deleteTrustsUser(trustsUserDeleteDto: $trustsUserDeleteDto) {
      success
      errorMessage
    }
  }
`;
